import React, { FC } from 'react';
import { useDrawerNavigation } from '@minecraft.drawer';
import { FilterDrawerProps, FilterDrawerType, FiltersCategoryNameEnum } from '../../shared/types';
import {
  AgeCategory,
  BookedOutDatesCategory,
  EthnicAppearanceCategory,
  ExcludeTalentWithConflictsCategory,
  GenderCategory,
  HeightAndWeightCategory,
  ProfileStatusCategory,
  RepresentationCategory,
  RosterListsCategory,
  UnionStatusCategory,
  WorkingLocationsCategory,
  SeekingRepresentationCategory,
} from '../../FilterDrawerCategories';

interface Props {
  filterPermissions: FilterDrawerProps['filterPermissions'];
  isSubmissionContext: boolean;
  type: FilterDrawerType;
  roleId: number;
}

const TopFiltersSection: FC<Props> = ({ filterPermissions, isSubmissionContext, type, roleId }) => {
  const { shouldCategoryBeVisible } = useDrawerNavigation();
  const { allowRepresentationCategory = true, allowAdditionalIdentifies = true } = filterPermissions;

  const isCasting = type === FilterDrawerType.Casting;
  const isReps = type === FilterDrawerType.Reps;
  const isTalentScout = type === FilterDrawerType.TalentScout;

  return (
    <>
      {isTalentScout && shouldCategoryBeVisible(FiltersCategoryNameEnum.seekingRepresentation) && (
        <SeekingRepresentationCategory />
      )}
      {isReps && shouldCategoryBeVisible(FiltersCategoryNameEnum.profileStatus) && (
        <ProfileStatusCategory type={type} />
      )}
      {isCasting && allowRepresentationCategory && shouldCategoryBeVisible(FiltersCategoryNameEnum.representation) && (
        <RepresentationCategory isSubmissionContext={isSubmissionContext} type={type} roleId={roleId} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.unionStatus) && <UnionStatusCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.genderAppearance) && (
        <GenderCategory allowAdditionalIdentifies={allowAdditionalIdentifies} type={type} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.ethnicAppearance) && <EthnicAppearanceCategory type={type} />}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.age) && (
        <AgeCategory isCasting={isCasting} isReps={isReps} type={type} />
      )}
      {shouldCategoryBeVisible(FiltersCategoryNameEnum.workingLocations) && <WorkingLocationsCategory type={type} />}
      {isCasting && shouldCategoryBeVisible(FiltersCategoryNameEnum.heightAndWeight) && (
        <HeightAndWeightCategory type={type} />
      )}
      {isReps && shouldCategoryBeVisible(FiltersCategoryNameEnum.rosterLists) && <RosterListsCategory type={type} />}
      {isReps && shouldCategoryBeVisible(FiltersCategoryNameEnum.excludeTalentWithConflicts) && (
        <ExcludeTalentWithConflictsCategory type={type} />
      )}
      {isReps && shouldCategoryBeVisible(FiltersCategoryNameEnum.bookedOutDates) && (
        <BookedOutDatesCategory type={type} />
      )}
    </>
  );
};

export default TopFiltersSection;
